module.exports = __webpack_public_path__ + "static/media/img-emandamento-sansiro-05.4a56eb2c.jpg";